import { type OrganizationOption, useOrganizationOptions } from './OrganizationFilter';
import { ReportingMultiSelect } from './ReportingMultiSelect';

type Props = {
	value: OrganizationOption[];
	onChange: (value: OrganizationOption[]) => void;
};

export const OrganizationsFilter = ({ value, onChange }: Props) => {
	const { options, loading } = useOrganizationOptions();

	return (
		<ReportingMultiSelect
			label='Organizations'
			loading={loading}
			options={options}
			value={value}
			getOptionId={(option) => option.id}
			getOptionLabel={(option) => option.name}
			onChange={onChange}
		/>
	);
};
